import { useEffect, useRef } from 'react'
import { caracLisHtml, serializeEditorUl } from './caracRich'

type Cmd = 'bold' | 'italic' | 'underline'

/** Editor ligero de texto enriquecido para las características: cada línea es una
 *  viñeta (WYSIWYG) y se puede aplicar negrita/cursiva/subrayado a la selección.
 *  Guarda en el formato acotado de caracRich (líneas "\n" con inline b/i/u). */
export function CaracRichEditor({ value, onChange, placeholder }: {
  value: string
  onChange: (v: string) => void
  placeholder?: string
}) {
  const ref = useRef<HTMLUListElement>(null)
  // Última cadena con la que se sincronizó el DOM: evita reescribir el innerHTML
  // (y perder el cursor) mientras el usuario teclea.
  const lastSync = useRef<string | null>(null)

  useEffect(() => {
    const el = ref.current
    if (!el || lastSync.current === value) return
    lastSync.current = value
    el.innerHTML = caracLisHtml(value) || '<li><br></li>'
  }, [value])

  function emit() {
    const el = ref.current
    if (!el) return
    const next = serializeEditorUl(el)
    lastSync.current = next
    onChange(next)
  }

  function cmd(c: Cmd) {
    ref.current?.focus()
    try { document.execCommand('styleWithCSS', false, 'false') } catch { /* noop */ }
    document.execCommand(c)
    emit()
  }

  const isEmpty = !value.trim()

  return (
    <div className="fc-rte edit-only">
      <div className="fc-rte__toolbar">
        <button type="button" className="fc-rte__btn" title="Negrita"
          onMouseDown={(e) => e.preventDefault()} onClick={() => cmd('bold')}><b>B</b></button>
        <button type="button" className="fc-rte__btn" title="Cursiva"
          onMouseDown={(e) => e.preventDefault()} onClick={() => cmd('italic')}><i>I</i></button>
        <button type="button" className="fc-rte__btn" title="Subrayado"
          onMouseDown={(e) => e.preventDefault()} onClick={() => cmd('underline')}><u>U</u></button>
      </div>
      <div className="fc-rte__wrap">
        <ul
          ref={ref}
          className="fc-carac-list fc-rte__area"
          contentEditable
          suppressContentEditableWarning
          onInput={emit}
        />
        {isEmpty && placeholder && <div className="fc-rte__ph">{placeholder}</div>}
      </div>
    </div>
  )
}
